import React, { useEffect } from "react";
import { X, MessageCircle } from "lucide-react";

const SUPPORT_URL = "https://t.me/Cgpeers_invites";

export default function HelpModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const openSupportChat = (e) => {
    e.preventDefault();
    if (window.Telegram?.WebApp?.openTelegramLink) {
      window.Telegram.WebApp.openTelegramLink(SUPPORT_URL);
    } else {
      window.open(SUPPORT_URL, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      <div
        className="relative w-full max-w-sm rounded-2xl border border-[#333] shadow-2xl overflow-hidden"
        style={{
          background:
            "linear-gradient(160deg, rgba(36,36,42,0.98) 0%, rgba(22,22,26,0.98) 100%)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 p-5 pb-3">
          <div className="flex items-center gap-3">
            <div
              className="flex items-center justify-center rounded-full"
              style={{
                width: 40,
                height: 40,
                background:
                  "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.18), rgba(255,255,255,0.04))",
                border: "1px solid rgba(255,255,255,0.12)",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="text-white"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9.146 9.074a2.998 2.998 0 0 1 5.28-.838A3 3 0 0 1 12 13v1m0 7a9 9 0 1 1 0-18a9 9 0 0 1 0 18m.05-4v.1h-.1V17z"
                />
              </svg>
            </div>
            <div>
              <h2 className="text-white text-lg font-semibold leading-tight">
                Need help?
              </h2>
              <p className="text-xs text-gray-400 mt-0.5">Support & feedback</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-5 pb-5 pt-2">
          <p className="text-sm text-gray-300 leading-relaxed mb-5">
            Have a question, suggestion, or feedback about the app? Reach out —
            we&apos;re happy to help and always open to ideas for improvement.
          </p>

          <button
            type="button"
            onClick={openSupportChat}
            className="w-full flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-white transition-all duration-200 active:scale-[0.98] hover:brightness-110"
            style={{
              background: "linear-gradient(135deg, #2AABEE 0%, #229ED9 100%)",
              boxShadow: "0 8px 24px rgba(34, 158, 217, 0.25)",
            }}
          >
            <MessageCircle size={18} />
            Open Chat
          </button>

          <p className="mt-3 text-center text-[11px] text-gray-500">
            Opens a Telegram chat with the admin
          </p>
        </div>
      </div>
    </div>
  );
}
